import { BaseError } from '@dynamic-labs-sdk/client';

type InvalidAmountErrorParams = {
  amountInSatoshis: number;
  reason: string;
};

export class InvalidAmountError extends BaseError {
  public readonly amountInSatoshis: number;

  constructor({ amountInSatoshis, reason }: InvalidAmountErrorParams) {
    super({
      cause: null,
      code: 'invalid_amount_error',
      details: `Amount: ${amountInSatoshis} satoshis`,
      docsUrl: null,
      name: 'InvalidAmountError',
      shortMessage: reason,
    });

    this.amountInSatoshis = amountInSatoshis;
  }
}
